module.exports = __webpack_public_path__ + "static/media/bergler.46eacdab.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/bergler.webp
// module id = 798
// module chunks = 0